import { Button } from '@bridebook/aura';
import { External } from '@bridebook/aura/src/icons';
import { getScreenType } from '@bridebook/web/lib/app/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import openInBrowser from '@bridebook/web/lib/utils/open-in-browser';
import { useTranslation } from 'next-i18next';
import { SummarySection, SummarySectionTitle } from './summary-section';

interface IProps {
  websiteUrl: string;
}

export const CampaignSummaryWebsiteSection = ({ websiteUrl }: IProps) => {
  const { t } = useTranslation('inbox');

  const handleOpenWebsite = async () => {
    await openInBrowser(websiteUrl);
  };

  const { isMobile } = useSelector(getScreenType);

  const OpenWeddingWebsiteButton = () => {
    if (isMobile) {
      return (
        <Button variant="secondary" size="sm" onClick={handleOpenWebsite} icon={External}>
          {t('guests.messageSummary.weddingWebsiteButton')}
        </Button>
      );
    }

    return (
      <a href={websiteUrl} target="_blank" rel="noopener noreferrer">
        <Button variant="secondary" size="sm" icon={External}>
          {t('guests.messageSummary.weddingWebsiteButton')}
        </Button>
      </a>
    );
  };

  return (
    <SummarySection>
      <SummarySectionTitle>{t('guests.messageSummary.shareLink')}</SummarySectionTitle>
      <div className="w-fit">{websiteUrl && <OpenWeddingWebsiteButton />}</div>
    </SummarySection>
  );
};
